<template lang="pug">
.form-input-standard-user-reservations-function.w-100
  .content.d-flex.flex-row.align-items-center
    span.error-message 詳細設定は面会予約を使用可にしないと有効になりません。

  // 訪問面会の基本設定使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getReservationsFunctionName("useReservationSettings") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useReservationSettings")
  // 訪問面会日時の設定使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getReservationsFunctionName("useReservationSchedules") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useReservationSchedules")
  // オンライン面会の基本設定使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getReservationsFunctionName("useOnlineReservationSettings") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useOnlineReservationSettings")
  // オンライン面会日時の設定使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getReservationsFunctionName("useOnlineReservationSchedules") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useOnlineReservationSchedules")
  // 代理予約の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getReservationsFunctionName("useReserveInstead") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useReserveInstead")
  // 承諾/辞退/キャンセル/案内転送の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getReservationsFunctionName("useEditReservations") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useEditReservations")
  // 面会開始の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getReservationsFunctionName("useStartOnlineReservations") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useStartOnlineReservations")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { ReservationsFunction, reservationsFunctionNameMap } from "@/commons/services/Authorization";

import UsableFunctionSwitch from "@/pc/basics/UsableFunctionSwitch.vue";

/**
 * ### 一般ユーザーの使用機能選択コンポーネント(面会予約)
 */
@Component({
  components: {
    UsableFunctionSwitch
  }
})
export default class FormInputStandardUserReservationsFunction extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop()
  value!: ReservationsFunction;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): ReservationsFunction {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: ReservationsFunction) {
    this.$emit("input", newValue);

    return;
  }

  /**
   * ### 面会予約の項目名を返す
   */
  public getReservationsFunctionName(functionKeyName: string): string {
    const functionName: string | undefined = reservationsFunctionNameMap.get(functionKeyName);
    return functionName ? functionName : "";
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.form-input-standard-user-reservations-function {
  margin-bottom: 12px;
  padding: 12px 12px 4px 12px;

  background-color: $hitomeq-gray;

  .content {
    margin-bottom: 8px;
    padding-right: 74px;

    .function-detail-name {
      margin-left: 16px;
    }
  }
}
</style>
